import React, { useRef, useEffect } from "react";
import { DoctorDto } from "../../types/doctor";

interface DoctorSearchSectionProps {
  lastName: string;
  setLastName: (val: string) => void;
  firstName: string;
  setFirstName: (val: string) => void;
  amka: string;
  setamka: (val: string) => void;
  selectedDoctor: DoctorDto | null;
  setSelectedDoctor: (doctor: DoctorDto | null) => void;
  isDropdownOpen: boolean;
  setIsDropdownOpen: (open: boolean) => void;
  filteredDoctors: DoctorDto[];
  isDoctorsLoading: boolean;
  onSelectDoctor: (doctor: DoctorDto) => void;
}

export const DoctorSearchSection: React.FC<DoctorSearchSectionProps> = ({
  lastName,
  setLastName,
  firstName,
  setFirstName,
  amka,
  setamka,
  selectedDoctor,
  setSelectedDoctor,
  isDropdownOpen,
  setIsDropdownOpen,
  filteredDoctors,
  isDoctorsLoading,
  onSelectDoctor,
}) => {
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [setIsDropdownOpen]);

  const showResults =
    isDropdownOpen &&
    !selectedDoctor &&
    (lastName.length >= 2 || firstName.length >= 2 || amka.length >= 2);

  return (
    <div
      ref={dropdownRef}
      className="p-4 bg-gray-50 rounded-lg border space-y-3 relative"
    >
      <div className="flex justify-between items-center">
        <h4 className="text-xs font-bold uppercase tracking-wider text-gray-500">
          Στοιχεία Ιτρού
        </h4>
        {selectedDoctor && (
          <span className="text-xs bg-green-100 text-green-700 font-semibold px-2 py-0.5 rounded-full">
            ✓ Επιλεγμένος Ιατρός (ID: {selectedDoctor.doctorId || selectedDoctor.id})
          </span>
        )}
      </div>

      <div className="grid grid-cols-3 gap-3">
        <div>
          <label className="block text-xs font-semibold text-gray-600">
            Επώνυμο *
          </label>
          <input
            type="text"
            required
            value={lastName}
            onChange={(e) => {
              setLastName(e.target.value);
              setIsDropdownOpen(true);
              if (selectedDoctor) setSelectedDoctor(null);
            }}
            onFocus={() => setIsDropdownOpen(true)}
            className="w-full mt-1 p-2 border rounded-lg text-sm bg-white focus:ring-2 focus:ring-primary focus:outline-none"
            placeholder="π.χ. Σολόβος"
          />
        </div>

        <div>
          <label className="block text-xs font-semibold text-gray-600">
            Όνομα *
          </label>
          <input
            type="text"
            required
            value={firstName}
            onChange={(e) => {
              setFirstName(e.target.value);
              setIsDropdownOpen(true);
              if (selectedDoctor) setSelectedDoctor(null);
            }}
            onFocus={() => setIsDropdownOpen(true)}
            className="w-full mt-1 p-2 border rounded-lg text-sm bg-white focus:ring-2 focus:ring-primary focus:outline-none"
            placeholder="π.χ. Ευάγγελος"
          />
        </div>

        <div>
          <label className="block text-xs font-semibold text-gray-600">
            ΑΜΚΑ*
          </label>
          <input
            type="text"
            required
            value={amka}
            onChange={(e) => {
              setamka(e.target.value);
              setIsDropdownOpen(true);
              if (selectedDoctor) setSelectedDoctor(null);
            }}
            onFocus={() => setIsDropdownOpen(true)}
            className="w-full mt-1 p-2 border rounded-lg text-sm bg-white focus:ring-2 focus:ring-primary focus:outline-none"
            placeholder="AMKA"
          />
        </div>
      </div>

      {showResults && (
        <div className="mt-2 bg-white border border-gray-200 rounded-lg shadow-lg max-h-48 overflow-y-auto divide-y divide-gray-100 z-20 absolute left-4 right-4 top-full">
          {isDoctorsLoading ? (
            <div className="p-3 text-sm text-gray-500 text-center">
              Αναζήτηση ιατρών...
            </div>
          ) : filteredDoctors.length > 0 ? (
            filteredDoctors.map((d: DoctorDto) => (
              <button
                key={d.doctorId || d.id}
                type="button"
                onClick={() => onSelectDoctor(d)}
                className="w-full text-left px-4 py-2 text-sm hover:bg-blue-50 flex justify-between items-center transition-colors"
              >
                <div>
                  <span className="font-semibold text-gray-800">
                    {d.lastName} {d.firstName}
                  </span>
                </div>
                <span className="text-xs font-mono text-gray-500 bg-gray-100 px-2 py-0.5 rounded">
                  ΑΜΚΑ: {d.amka}
                </span>
              </button>
            ))
          ) : (
            <div className="p-3 text-sm text-gray-500 text-center">
              Δε βρέθηκε ιατρός με αυτά τα στοιχεία.
            </div>
          )}
        </div>
      )}
    </div>
  );
};